import "../../styles/blocks/contact-page/tabs-category.scss";

import React, {useState} from "react";
import handleize from "../../helpers/handleize";
import cn from "classnames";
import Collapse from "../Animations/Collapse";

const TabWorkWithUsCategory = ({ category, required = false }) => {
    let {
        categoryValuesType,
        description,
        label,
        hiddenValues,
        type: values,
    } = category;
    const [showValues, setShowValues] = useState(!hiddenValues);

    return (
        <div className="contact-tabs__category ctc">
            <div className={cn(
                "ctc__label",
                !hiddenValues && "ctc__label--centered"
            )}>
                <label className="ctc__label-switch">
                    <h2 className="ctc__label-text">
                        {label}

                        {required && (
                            <span className="ctc__label-star">*</span>
                        )}
                    </h2>

                    <input
                        type="checkbox"
                        required={required}
                        disabled={!hiddenValues}
                        onChange={(event) => setShowValues(event.target.checked)}
                    />

                    {hiddenValues && <div className="ctc__label-slider" />}
                </label>
            </div>

            {description
                ? (
                    <div className={cn(
                        "ctc__description",
                        !hiddenValues && "ctc__description--centered"
                    )}>
                        {description}
                    </div>
                )
                : null
            }

            <Collapse open={showValues} className="ctc__values-animate" delay={0.1} space="1.5rem">
                <ul className="ctc__values">
                    {values.map((value, index) => {
                        return (
                            <li className="ctc__value" key={index}>
                                <label className="ctc__value-card">
                                    <p className="ctc__value-label">
                                        {value.label}
                                    </p>

                                    {value.description
                                        ? (
                                            <p className="ctc__value-description">
                                                {value.description}
                                            </p>
                                        )
                                        : null
                                    }

                                    <input
                                        type={categoryValuesType}
                                        name={handleize(label).replaceAll('-', '_')}
                                        value={value.label}
                                        required={required}
                                    />

                                    <div className={cn(
                                        "ctc__value-button",
                                        `ctc__value-button--${categoryValuesType}`,
                                    )} />
                                </label>
                            </li>
                        )
                    })}
                </ul>
            </Collapse>
        </div>
    );
}

export default TabWorkWithUsCategory;
